import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { apiRequest } from "src/async/apiUtils";
import { isEqual } from "src/hooks/useHasChanges";

export const SiteContext = createContext();

export const SiteSettingsProvider = ({ children }) => {
  const [siteLoading, setSiteLoading] = useState(true);
  const [site, setSite] = useState({});

  const loadSiteSettings = useCallback(async () => {
    setSiteLoading(true);
    try {
      const url = "portal/site-settings/details";
      const { data: resData } = await apiRequest("GET", `/${url}`);

      const newSettings = resData.data;

      setSite((prevSite) => {
        if (!isEqual(prevSite, newSettings)) {
          return newSettings;
        }
        return prevSite;
      });

      return newSettings;
    } catch (err) {
      if (axios.isCancel(err) || err?.name === "CanceledError" || err?.code === "ERR_CANCELED" || err?.message === "canceled") {
        return;
      }
      toast.error(err.message);
    } finally {
      setSiteLoading(false);
    }
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === "LOGIN_SUCCESS") {
        loadSiteSettings();
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [loadSiteSettings]);

  return (
    <SiteContext.Provider
      value={{
        loading: siteLoading,
        site,
        setSite,
        reloadSettings: loadSiteSettings,
      }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteContext);
